export default __webpack_public_path__ + "img/55070343580860b3bc282093aabbe9e3.png";